const ModalPolicy = ({ showModal }) => {
  return (
    <div className="modalsWrapper">
      <div className="backdrop" onClick={() => showModal(false)}></div>

      <div className="modalsContainer">
        <div className="header">
          <p className="modalTitle">Terms and Conditions</p>
          <button className="closeButton" onClick={() => showModal(false)}>
            <img src="/close.png" alt="X" />
          </button>
        </div>

        <div p className="modalText">
          <p className="termsTitle">Terms and Conditions for Batery.ai Promotion</p>

          <p className="termsText">
            These terms and conditions govern the procedure for holding the event “Update your jersey” by Batery.ai
            aimed at attracting the attention of new clients to the activities of the Event organizer and increasing the
            activity of clients of the Event organizer. Event organizer: BATERY ENTERPRISES PRIVATE LIMITED, Corporate
            Identity Number of the company is U58203DL2023PTC413415, with registered address at 9130, B-9, Vasant Kunj,
            New Delhi, South Delhi, Delhi, 110070
          </p>

          <p className="termsTitle">2. Promotion Details</p>

          <p className="termsText">
            Eligibility: Participation is open to individuals above the age of 18. By participating, you confirm that
            you are over 18 years of age. Jersey Exchange Requirement: To receive a new jersey, participants must: -
            make a registration on Landing page updatejearsey.batery.ai - bring an old East Bengal jersey from previous
            seasons to the Batery Zone on the game day, December 22nd. Event Date: Participants must attend the home
            game on December 22nd to exchange their jersey and receive a new one, autographed by East Bengal Player.
            Limitation: Participation is limited to once per person, defined by a unique combination of IP address,
            device, operating system, email, or phone number. Event organizer can change date of promotional or
            requirements without additional notes
          </p>

          <p className="termsTitle">3. Data Collection and Use</p>

          <p className="termsText">
            Purpose of Data Collection: The personal data collected, including phone number, email address, name,
            preferred jersey size, and favorite team player, will be used for identification at the event, preparation
            of jerseys, and website analytics. Data Sharing and Usage: We reserve the right to share your data with
            third-party organizations and use it for promotional broadcasts, messaging, and marketing purposes. Consent:
            By participating, you consent to the collection, use, and sharing of your data as described.
          </p>

          <p className="termsTitle">4. Company Information</p>

          <p className="termsText">
            Name: BATERY ENTERPRISES PRIVATE LIMITED Address: 9130, B-9, Vasant Kunj, New Delhi, South Delhi, Delhi,
            110070 Email: info@batery.ai
          </p>

          <p className="termsTitle">5. Consent and Agreement</p>

          <p className="termsText">
            By participating in this promotion, you agree to these Terms and Conditions, including our data collection,
            usage, and sharing practices.
          </p>

          <p className="termsTitle">6. Amendments</p>
          <p className="termsText">
            We reserve the right to modify these terms at any time. Continued participation constitutes acceptance of
            these changes.
          </p>

          <p className="termsTitle">7. Grievance Officer</p>

          <p className="termsText">
            Contact details of the Grievance Officer will be provided, addressing any concerns or complaints regarding
            the promotion.
          </p>

          <p className="termsTitle">8. Jurisdiction</p>

          <p className="termsText">
            These terms are governed by the laws of India, and any disputes will be subject to the jurisdiction of the
            courts in India.
          </p>
        </div>

        <div className="buttonBlock">
          <button onClick={() => showModal(false)}>Done</button>
        </div>
      </div>
    </div>
  );
};

export default ModalPolicy;
